import { render, staticRenderFns } from "./ReporteAutorizacionesFolios.vue?vue&type=template&id=2da6b62e"
import script from "./ReporteAutorizacionesFolios.vue?vue&type=script&lang=js"
export * from "./ReporteAutorizacionesFolios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports